module.exports = __webpack_public_path__ + "img/usmf-logo.d6e47742.png";